import { useEffect, useState, useRef } from "react";
import { fetchStats, trackVisit } from "@/lib/stats";

const fmt = (n) => (n || 0).toLocaleString("de-DE");

export default function StatsBar() {
  const [s, setS] = useState({ visitors: 0, android: 0, ios: 0 });
  const visited = useRef(false);

  useEffect(() => {
    if (visited.current) return;
    visited.current = true;
    trackVisit();
    setTimeout(() => fetchStats().then(setS), 500);
  }, []);

  const items = [
    { key: "visitors", label: "Besucher", value: s.visitors, color: "#8B5CF6", testid: "stat-visitors" },
    { key: "android", label: "Android Downloads", value: s.android, color: "#22C55E", testid: "stat-android" },
    { key: "ios", label: "iOS Downloads", value: s.ios, color: "#00E5FF", testid: "stat-ios" },
  ];

  return (
    <section id="stats" data-testid="stats-section" className="border-b border-white/10">
      <div className="mx-auto grid max-w-6xl grid-cols-3 divide-x divide-white/10 px-5 lg:px-8">
        {items.map(({ key, label, value, color, testid }) => (
          <div key={key} data-testid={testid} className="py-6 pl-4 first:pl-0 sm:py-8 sm:pl-8">
            <div className="font-display text-2xl font-semibold tabular-nums text-white sm:text-3xl">{fmt(value)}</div>
            <div className="mt-1 flex items-center gap-2 text-[11px] uppercase tracking-widest text-white/45 sm:text-xs">
              <span className="h-1.5 w-1.5 rounded-full" style={{ background: color }} />
              {label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
